import {
  ApplicationConfig,
  inject,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { appRoutes } from './app.routes';
import { authInterceptor, errorInterceptor, httpErrorInterceptor } from '@call-center/core';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from './environments/environment';
import { AUTH_CONFIG } from '@call-center/core/auth';

import {
  BASE_CONFIG,
  providePrimeNgConfig,
} from '@call-center/core/configuration';
import { MessageService } from 'primeng/api'; 
import { PermissionStore } from '@call-center/core/permission';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(appRoutes),
    provideHttpClient(
      withInterceptors([authInterceptor, errorInterceptor, httpErrorInterceptor])
    ),
    providePrimeNgConfig(),
    {
      provide: AUTH_CONFIG,
      useValue: { authUrl: environment.authUrl },
    },
    {
      provide: BASE_CONFIG,
      useValue: { baseUrl: environment.baseUrl },
    },
    ...TranslateModule.forRoot({
      defaultLanguage: 'fa',
    }).providers,
    ...provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    })
  ],
};
